import { StrategyDetailsPageInvestmentEntitiesQuery } from '@/__generated__/graphql';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import { Loader } from '@/components/loaders/loader';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import { TableColumns } from '@/components/table/types';
import { useAuth } from '@/hooks/use-auth';
import { formatPercentage } from '@/shared/utils/percentage';
import { TenantType } from '@trace-8/trace8-schema';

interface MobileTableEntityProps {
  columns: TableColumns[];
  entityTableRows: StrategyDetailsPageInvestmentEntitiesQuery['InvestmentEntities']['entities'];
  loading: boolean;
  openInvestorDetailsPage: ({ investorId, entityId }: { investorId: string; entityId?: string }) => void;
}

const MobileTableEntity = ({ columns, entityTableRows, loading, openInvestorDetailsPage }: MobileTableEntityProps) => {
  const { user } = useAuth();

  if (loading) return <Loader />;

  const TableRow = ({ el }: { el: StrategyDetailsPageInvestmentEntitiesQuery['InvestmentEntities']['entities'][number] }) => {
    return (
      <MobileTableRowWrap key={el.id}>
        <MobileRow>
          <MobileRowTitle>{columns[0].title}</MobileRowTitle>
          <MobileRowValue onClick={() => openInvestorDetailsPage({ investorId: el.familyId, entityId: el.id })} isRedirect>
            {el.name}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[1].title}</MobileRowTitle>
          <MobileRowValue onClick={() => openInvestorDetailsPage({ investorId: el.familyId })} isRedirect>
            {el.family}
          </MobileRowValue>
        </MobileRow>

        {user && user.tenant.type === TenantType.PLATFORM_MANAGER && (
          <MobileRow>
            <MobileRowTitle>{columns[2].title}</MobileRowTitle>
            <MobileRowValue>{el.tenant.name}</MobileRowValue>
          </MobileRow>
        )}

        <MobileRow>
          <MobileRowTitle>{columns[3].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip zIndex={1000}>{el.committedCapital}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[4].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip zIndex={1000}>{el.capitalCalled}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[5].title}</MobileRowTitle>
          <MobileRowValue>{formatPercentage(el.percentOfCapitalCalled)}</MobileRowValue>
        </MobileRow>
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {entityTableRows.length ? (
        entityTableRows.map((el) => {
          return <TableRow el={el} key={el.id} />;
        })
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTableEntity;
